// extracted by mini-css-extract-plugin
module.exports = {"navlink":"index_navlink__5kVfe"};